import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatInput, MatLabel, MatSuffix } from '@angular/material/input';
import { MatDivider } from '@angular/material/list';
import { EmptyStateModule } from '@michelin/theme';
import { Groups } from 'src/app/interfaces/groups';
import { ApplicationService } from '../application.service';
import { GroupElementComponent } from './group-element/group-element.component';

@Component({
  selector: 'mic-app-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.scss'],
  imports: [
    MatFormField,
    MatLabel,
    MatInput,
    ReactiveFormsModule,
    MatIconButton,
    MatSuffix,
    MatIcon,
    GroupElementComponent,
    MatDivider,
    EmptyStateModule
  ]
})
export class GroupComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly appService = inject(ApplicationService);
  private readonly cdr = inject(ChangeDetectorRef);

  private readonly loginMaxLength = 200;
  groups: Groups[] = [];
  resultSearch: Groups[] = [];
  search = new FormControl();
  searchValue = '';

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      if (params['name'] !== 'hbi') {
        this.appService.getApplicationByName(this.route.snapshot.params['name']).subscribe((response) => {
          this.groups = response.groups;
          this.resultSearch = this.groups;
          this.cdr.detectChanges();
        });
      }
    });
    this.search.valueChanges.pipe(debounceTime(this.loginMaxLength), distinctUntilChanged()).subscribe((search: string) => {
      this.resultSearch = this.groups.filter(function (params) {
        return params.name.toLowerCase().includes(search.trim().toLowerCase());
      });
      this.searchValue = search;
      this.cdr.detectChanges();
    });
  }
  clearSearch() {
    this.search.setValue('');
    this.searchValue = '';
    this.cdr.detectChanges();
  }

  deleteGroup(groupId: number): void {
    this.groups = this.groups.filter((gr) => gr.id !== groupId);
    this.resultSearch = this.groups;
    this.cdr.detectChanges();
  }
}
